import { LiSnType } from "@/enum/li-sn.enum";

import { LiSn } from "../schema/liSn";

export const initialState: LiSn = {
	name: "",
	id: 0,
	liSnResults: [],
	currentCompany: [],
	companyHeadcount: [],
	pastCompanyList: [],
	companyType: [],
	companyHeadquarterLocation: [],
	function: [],
	currentJobTitle: [],
	seniorityLevel: [],
	pastJobTitle: [],
	yearsInCurrentCompany: [],
	yearsInCurrentPosition: [],
	geography: [],
	industry: [],
	firstName: "",
	lastName: "",
	profileLanguage: [],
	yearsOfExperience: [],
	school: [],
	connectionsOf: [],
	followingYourCompany: false,
	viewedYourProfileRecently: false,
	pastColleague: false,
	sharedExperiences: false,
	changedJob: false,
	postedOnLinkedin: false,
	type: LiSnType.SPECIFIC,
};
